import React, { FC } from 'react';
import { observer } from "mobx-react-lite";

const CopyMessage: FC = () => {
    return (
        <div className="copy_msg">Copied</div>
    );
};

export default observer(CopyMessage);